import { Card, CardContent, CardHeader, CardTitle } from '../../../../ui/common-ui/card';
import { Alert } from '../../types/alerts';
import { AlertTriangle, CheckCircle } from 'lucide-react';

interface AlertStatsProps {
  alerts: Alert[];
}

export const AlertStats = ({ alerts }: AlertStatsProps) => {
  const stats = {
    total: alerts.length,
    enabled: alerts.filter(a => a.isEnabled).length,
    critical: alerts.filter(a => a.severity === 'Critical').length,
    high: alerts.filter(a => a.severity === 'High').length,
    medium: alerts.filter(a => a.severity === 'Medium').length,
  };

  const statCards = [
    {
      title: 'Total Alerts',
      value: stats.total,
      icon: AlertTriangle,
      className: 'text-primary',
    },
    {
      title: 'Enabled',
      value: stats.enabled,
      icon: CheckCircle,
      className: 'text-green-500',
    },
    {
      title: 'Critical',
      value: stats.critical,
      icon: AlertTriangle,
      className: 'text-red-500',
    },
    {
      title: 'High',
      value: stats.high,
      icon: AlertTriangle,
      className: 'text-orange-500',
    },
    {
      title: 'Medium',
      value: stats.medium,
      icon: AlertTriangle,
      className: 'text-yellow-500',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {statCards.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card key={stat.title} className="rounded-2xl bg-card portal-card-elevated portal-card-hover">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">
                {stat.title}
              </CardTitle>
              <Icon className={`h-4 w-4 ${stat.className}`} />
            </CardHeader>
            <CardContent>
              <div className={`text-2xl font-bold ${stat.className}`}>
                {stat.value}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
